import _ from 'lodash';
import { filesize } from 'filesize';
import configuration from '../../utils/configuration';
import { getExtname } from '../utils/helper';

function validatePostFiles (files = []) {
  let limit = _.toNumber(configuration.get('configData.post_files_count_limit'));;
  if (files.length > limit) {
    return {
      status: false,
      message: `You can't upload more than ${limit} files!`,
    };
  }
  limit = _.toNumber(configuration.get('configData.post_file_size_limit')) * 1000000;
  let invalidFiles = files.filter((file) => file.size > limit);
  if (invalidFiles.length > 0) {
    return {
      status: false,
      message: `You can't upload a file larger than ${filesize(limit)}!`,
    };
  }
  invalidFiles = files.filter((file) => !isValidFileType(file.name));
  if (invalidFiles.length > 0) {
    return {
      status: false,
      message: `${getExtname(invalidFiles[0].name)} files are not supported!`,
    };
  }
  return { status: true, message: null };
}

function validateMessageFiles (files = []) {
  let limit = _.toNumber(configuration.get('configData.chatroom_message_attachments_count_limit'));
  if (files.length > limit) {
    return {
      status: false,
      message: `You can't upload more than ${limit} files!`,
    };
  }
  limit = _.toNumber(configuration.get('configData.chatroom_message_attachments_size_limit')) * 1000000;
  let invalidFiles = files.filter((file) => file.size > limit);
  if (invalidFiles.length > 0) {
    return {
      status: false,
      message: `You can't upload a file larger than ${filesize(limit)}!`,
    };
  }
  invalidFiles = files.filter((file) => !isValidFileType(file.name));
  if (invalidFiles.length > 0) {
    return {
      status: false,
      message: `${getExtname(invalidFiles[0].name)} files are not supported!`,
    };
  }
  return { status: true, message: null };
}

function validateShowcaseFiles(files = [], oldFiles = []) {
  let limit = _.toNumber(configuration.get('configData.maximum_number_of_media_files_for_showcase') || 5);
  if (files.length + oldFiles.length > limit) {
    return {
      status: false,
      message: `You can't upload more than ${limit} files!`,
    };
  }

  limit = _.toNumber(configuration.get('configData.showcase_file_size_limit') || 3000) * 1000000;
  let invalidFiles = files.filter((file) => file.size > limit);
  if (invalidFiles.length > 0) {
    return {
      status: false,
      message: `You can't upload a file larger than ${filesize(limit)}!`,
    };
  }
  invalidFiles = files.filter((file) => !isValidImageType(file.name));
  if (invalidFiles.length > 0) {
    return {
      status: false,
      message: `${getExtname(invalidFiles[0].name)} files are not supported!`,
    };
  }
  return { status: true, message: null };
}

function getValidFileTypes() {
  return [
    ...configuration.get('configData.content_image_mime').split(','),
    ...configuration.get('configData.content_video_mime').split(','),
  ];
}

function isValidFileType(filename) {
  const extension = getExtname(filename).replace('.', '');
  return getValidFileTypes().includes(extension.toLowerCase());
}

function isValidImageType(filename) {
  const supportedFileTypes = configuration.get('configData.content_image_mime').split(',')

  const extension = getExtname(filename).replace('.', '');
  return supportedFileTypes.includes(extension.toLowerCase());
}

export default {
  isValidFileType,
  validatePostFiles,
  validateMessageFiles,
  validateShowcaseFiles
};
